/**
 * V2 레이아웃을 사용하는 페이지 목록
 * - 레거시 헤더/Nav 대신 V2 레이아웃 적용
 * - Header.js, HeaderMo.js에서 하단 탭(튜터/소크라테스) 숨김
 */
export const V2_PAGES = [
  "/tutor",
  "/my-air",
  "/socrates",
  "/result",
  "/my-activity",
  "/company-info",
];

/**
 * 상단 띠배너(HeaderBanner)를 표시하는 페이지 목록
 * - 랜딩 페이지(/)는 별도로 처리되므로 포함하지 않음
 */
export const BANNER_PAGES = [
  "/tutor",
  "/socrates",
  "/result",
  "/my-activity",
  "/company-info",
];

/**
 * 주어진 pathname이 페이지 목록에 포함되는지 확인
 */
export const isPageInList = (pathname: string, pages: string[]): boolean => {
  return pages.some((path) => pathname.startsWith(path));
};
